// extracted by mini-css-extract-plugin
module.exports = {"courseCard":"CourseCard-module--courseCard--eLtVi","courseHeader":"CourseCard-module--courseHeader--32UyK","courseBody":"CourseCard-module--courseBody--2GoLV"};